import { render } from "./customFooter.vue?vue&type=template&id=55f4b78a&scoped=true"
import script from "./customFooter.vue?vue&type=script&lang=js"
export * from "./customFooter.vue?vue&type=script&lang=js"

import "./customFooter.vue?vue&type=style&index=0&id=55f4b78a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55f4b78a"]])

export default __exports__